export default __webpack_public_path__ + "static/media/bird.2482dc35.svg";